import { LinkType, EditorType } from '../../constants';
import { getLinkType, getPageFromGotoPageAction } from '../helpers';
import { EditableItem, editableId } from '../htmlEditor/constants';
import constants from '../indesignEditor/constants';

export interface LinkConfig {
	id: string;
	page: number;
	href: string;
	isEditedFromBackoffice?: boolean;
}

interface LinksData {
	items: LinkConfig[];
	isError: boolean;
}

const getConfig = (element: HTMLElement, page: number, editorType: EditorType): LinkConfig => {
	const linkElement = element.closest('a');
	const { href, attributes } = linkElement as HTMLAnchorElement;
	const linkType = getLinkType(href);

	return {
		id: editorType === EditorType.INDESIGN
			? element.id
			: element.getAttribute(editableId) as string,
		page,
		href: linkType === LinkType.url
			? href
			: getPageFromGotoPageAction(attributes['onclick'].value), // tslint:disable-line no-string-literal
	};
};

const getLinkSelector = (editorType: EditorType): string => {
	if (editorType === EditorType.INDESIGN) {
		return `a [id*=${constants.parentContainerId}]:not([class*=${constants.lockedClassName}])`;
	}

	return `a [${EditableItem.Image}]`;
};

const isLockedEditableButton = (element: HTMLElement): boolean => {
	const isLinkOnImage = element.className.includes(constants.imageClassName) ||
		element.getAttribute(EditableItem.Image) !== null;

	if (isLinkOnImage) {
		return false;
	}

	const linkElement = element.closest('a');
	const lockedText = linkElement &&
		linkElement.parentElement &&
		linkElement.parentElement.querySelector(`[class*=${constants.textFieldClassName}][class*=${constants.lockedClassName}]`);

	return !!lockedText;
};

export default (page: number, htmlDocument: HTMLDocument, editorType: EditorType): LinksData => {
	const items: LinkConfig[] = [];
	let isError: boolean = false;

	const editableLinkElements = [
		...htmlDocument.querySelectorAll(getLinkSelector(editorType)),
	].filter((element: HTMLElement) => !isLockedEditableButton(element)) as HTMLElement[];

	try {
		editableLinkElements.forEach(element => (
			items.push(getConfig(element, page, editorType))
		));
	} catch (err) {
		isError = true;
	}

	return {
		items,
		isError,
	};
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/editableLinks/getData.ts